/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Incident_DateInputs */

const en_case_field_incident_date = /** @type {(inputs: Case_Field_Incident_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of incident`)
};

const pt_br2_case_field_incident_date = /** @type {(inputs: Case_Field_Incident_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data do sinistro`)
};

/**
* | output |
* | --- |
* | "Date of incident" |
*
* @param {Case_Field_Incident_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_incident_date = /** @type {((inputs?: Case_Field_Incident_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Incident_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_incident_date(inputs)
	return pt_br2_case_field_incident_date(inputs)
});